<template>
  <div class="summary-card" @click="$emit(event, target)">
    <div class="image-icon-container"><img v-bind:src="cardIcon" alt="card icon" /></div>
    <div class="details-display-container">
      <div class="summary-description">{{summaryDescription}}</div>
      <div class="summary-count">{{totalCount}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryCard',
  props:[
    'cardIcon',
    'summaryDescription',
    'totalCount',
    'eventType',
    'eventTarget',
  ],
  data(){
    return{
      event: this.eventType,
      target: this.eventTarget,
    };
  },
  computed: {
  },

  beforeMount(){

  },

  updated(){
  }

};
</script>

<style scoped>
  .summary-card{
    border-radius: 15px;
    padding:0 1.438rem;
    align-items:center;
    display:flex;
    justify-content:space-between;
    width:100%;
  }
  .image-icon-container img{
    max-width:100%;
  }
  .details-display-container{
    display:flex;
    flex-direction:column;
  }

  .summary-description{
    font-size:.8rem;
    color:#767676;
    font-weight:600;
    text-align:right;
  }
  .summary-count{
    text-align:right;
    margin-top:.813rem;
    font-size:2rem;
    color:#3F3F3F;
    font-weight:600;
  }

  @media only screen and (max-width:1178px) {

  }

  @media only screen and (max-width:1078px) {

  }

  @media only screen and (max-width:990px) {

  }

  @media only screen and (max-width: 767px) {

  }

  @media only screen and (max-width: 565px) {

  }

  @media only screen and (max-width: 420px) {

  }
</style>
